import React from 'react';
import { IconCard, SBCard } from './StatCard';

export default function BasicStatsView({ stats }) {
  return (
    <>
      <div>
        <dl className="mt-5 mb-10 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white border-2 sm:grid-cols-2 lg:grid-cols-4 md:divide-x md:divide-y-0">
          {stats.filter((s) => ['sip', 'checkin', 'list', 'load'].includes(s.key)).map((item) => (
            <SBCard key={item.name} item={item} />
          ))}
        </dl>
      </div>
      <div>
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          Trends
        </h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          Summary of user interaction with your listing in the past week, with trends from the week prior.
        </p>
        <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {stats.map((item) => (
            <IconCard key={item.name} item={item} />
          ))}
        </dl>
      </div>
    </>
  );
}
